import { scrollToRequiredElem } from './scroll';
import intersection from 'lodash/intersection';
import { isValid } from 'iban';

import { getCountries } from '../containers/Step2/utils';

const N_6 = 6;
const N_7 = 7;
const N_8 = 8;
const N_9 = 9;
const N_10 = 10;
const N_11 = 11;
const N_12 = 12;
const N_13 = 13;
const N_14 = 14;
const N_15 = 15;
const N_16 = 16;
const N_17 = 17;
const N_18 = 18;
const N_19 = 19;
const N_20 = 20;
const N_21 = 21;
const N_22 = 22;
const N_23 = 23;
const N_24 = 24;
const N_25 = 25;
const N_26 = 26;
const N_27 = 27;
const N_28 = 28;
const N_29 = 29;
const N_30 = 30;
const N_31 = 31;
const N_55 = 55;
const N_97 = 97;

const CHECK_CODE_EVEN = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  '6': N_6,
  '7': N_7,
  '8': N_8,
  '9': N_9,
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: N_6,
  H: N_7,
  I: N_8,
  J: N_9,
  K: N_10,
  L: N_11,
  M: N_12,
  N: N_13,
  O: N_14,
  P: N_15,
  Q: N_16,
  R: N_17,
  S: N_18,
  T: N_19,
  U: N_20,
  V: N_21,
  W: N_22,
  X: N_23,
  Y: N_24,
  Z: N_25
};

const CHECK_CODE_ODD = {
  0: 1,
  1: 0,
  2: 5,
  3: N_7,
  4: N_9,
  5: N_13,
  '6': N_15,
  '7': N_17,
  '8': N_19,
  '9': N_21,
  A: 1,
  B: 0,
  C: 5,
  D: N_7,
  E: N_9,
  F: N_13,
  G: N_15,
  H: N_17,
  I: N_19,
  J: N_21,
  K: 2,
  L: 4,
  M: N_18,
  N: N_20,
  O: N_11,
  P: 3,
  Q: N_6,
  R: N_8,
  S: N_12,
  T: N_14,
  U: N_16,
  V: N_10,
  W: N_22,
  X: N_25,
  Y: N_24,
  Z: N_23
};

const CHECK_CODE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const onSubmitFail = (errors) => {
  const requiredFields = Object.keys(errors);
  scrollToRequiredElem(requiredFields[0]);
};

export const checkCF = (codiceFiscale) => {
  if (typeof codiceFiscale !== 'string') return false;
  codiceFiscale = codiceFiscale.toUpperCase();
  if (codiceFiscale.length !== N_16) return false;
  const expectedCheckCode = codiceFiscale.charAt(N_15);
  const cf = codiceFiscale.slice(0, N_15);

  return getCheckCode(cf) === expectedCheckCode;
};

const getCheckCode = (codiceFiscale) => {
  let val = 0;
  for (let i = 0; i < N_15; i++) {
    const c = codiceFiscale[i];
    val += i % 2 ? CHECK_CODE_EVEN[c] : CHECK_CODE_ODD[c];
  }
  val = val % N_26;

  return CHECK_CODE_CHARS.charAt(val);
};

export const validIBAN = (function () {
  // Table of IBAN lengths per country
  const CODE_LENGTHS = {
    AD: N_24, AE: N_23, AT: N_20, AZ: N_28, BA: N_20, BE: N_16, BG: N_22, BH: N_22, BR: N_29,
    CH: N_21, CR: N_21, CY: N_28, CZ: N_24, DE: N_22, DK: N_18, DO: N_28, EE: N_20, ES: N_24,
    FI: N_18, FO: N_18, FR: N_27, GB: N_22, GI: N_23, GL: N_18, GR: N_27, GT: N_28, HR: N_21,
    HU: N_28, IE: N_22, IL: N_23, IS: N_26, IT: N_27, JO: N_30, KW: N_30, KZ: N_20, LB: N_28,
    LI: N_21, LT: N_20, LU: N_20, LV: N_21, MC: N_27, MD: N_24, ME: N_22, MK: N_19, MR: N_27,
    MT: N_31, MU: N_30, NL: N_18, NO: N_15, PK: N_24, PL: N_28, PS: N_29, PT: N_25, QA: N_29,
    RO: N_24, RS: N_22, SA: N_24, SE: N_24, SI: N_19, SK: N_24, SM: N_27, TN: N_24, TR: N_26
  };

  function mod97(string) {
    let checksum = string.slice(0, 2),
      fragment;

    for (let offset = 2; offset < string.length; offset += N_7) {
      fragment = String(checksum) + string.substring(offset, offset + N_7);
      checksum = parseInt(fragment, 10) % N_97;
    }

    return checksum;
  }

  return function (input) {
    const iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''),
      code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);

    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }

    const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - N_55;
    });

    return mod97(digits) === 1;
  };
}());

export const validateIBAN = ((iban) => {
  return isValid(iban);
});

export const geolocate = (change, cb, t) => {
  const autocompleteInput = document.getElementById('address');
  const observerHack = new MutationObserver(function() {
      observerHack.disconnect();
      autocompleteInput.setAttribute('autocomplete', 'new-password');
  });
  observerHack.observe(autocompleteInput, {
      attributes: true,
      attributeFilter: ['autocomplete']
  });

  const autocomplete = new window.google.maps.places.Autocomplete((document.getElementById('address')), {types: ['address']});
  autocomplete.addListener('place_changed', () => fillInAddress(autocomplete, change, cb, t));

  // 	autocomplete.setComponentRestrictions({
  // 		country: ['it'],
  // 	});

  if(navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      const geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      const circle = new window.google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy
      });
      autocomplete.setBounds(circle.getBounds());
    });
  }
};

const fillInAddress = (autocomplete, change, cb, t) => {
  const componentForm = {
    'address': {
      type: ['route'],
      name_type: 'short_name'
    },
    'numeroCivico': {
      type: ['street_number'],
      name_type: 'short_name'
    },
    'cap': {
      type: ['postal_code'],
      name_type: 'short_name'
    },
    'frazione': {
      type: ['locality'],
      name_type: 'long_name'
    },
    'citta': {
      type: ['locality', 'administrative_area_level_3'],
      name_type: 'short_name'
    },
    'provincia': {
      type: ['administrative_area_level_2'],
      name_type: 'short_name'
    },
    'nazione': {
      type: ['country'],
      name_type: 'short_name'
    }
  };

  const place = autocomplete.getPlace();

  for(const component in componentForm) {
    change(component, '');
  }

  if(cb) {
    cb(place.address_components);
  }

  if(place && place.address_components && place.address_components.length > 0) {
    let fraction = '', city = '';
    for(const component in componentForm) {
      for(let i = 0; i < place.address_components.length; i++) {
        if(intersection(place.address_components[i].types, componentForm[component].type).length > 0) {
          const value = place.address_components[i][componentForm[component].name_type];
          if(component === 'nazione') {
            const currCountry = getCountries(t).filter(c => c.value === value);
            if(currCountry.length) {
              change(component, currCountry[0]);
            }
          } else if(component === 'frazione') {
            fraction = value;
          } else {
            if(component === 'citta') {
              city = value;
            }
            change(component, value);
          }
        }
      }
    }
    if(fraction !== city) {
      change('frazione', fraction);
    }
  }
};
